export const appVersion = process.env.NEXT_PUBLIC_APP_VERSION!;
// previous version:

// https://semver.org/
